function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}

export default function () {
  return this.each(raise);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_d3-selection@1.4.1@d3-selection/src/selection/raise.js
// module id = 444
// module chunks = 0